import axios from 'axios';
import useAgent from '../../hooks/useAgent';
import url from '../hooks/url';

export const getTransactions = (params) => axios.get(url, { params });
export const useGetTransactions = () => useAgent(getTransactions);
